import { render, staticRenderFns } from "./TradeNameConfigs.vue?vue&type=template&id=57a10839"
import script from "./TradeNameConfigs.vue?vue&type=script&lang=js"
export * from "./TradeNameConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports